import { IsEnum, IsOptional } from 'class-validator';

import { AuctionStatusEnum } from '@onArte/shared/enums';
import { ListQuery } from '@onArte/shared/models/common';

export class AuctionOfferListQuery extends ListQuery {
  @IsOptional()
  @IsEnum(AuctionStatusEnum)
  public status?: AuctionStatusEnum;

  constructor(
    limit?: number,
    offset?: number,
    status?: AuctionStatusEnum
  ) {
    super(limit, offset);

    this.status = status;
  }
}
